import { SVG_Logo } from 'libs/images/SVG_Logo';
import { EColors, EFonts } from 'libs/styles/styling';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const LogoHeader = (props: Props): JSX.Element => {
    return (
        <S_LogoHeader className={props.className}>
            <>
                <Link to="/admin">
                    <S_SVG_Logo />
                </Link>
                <S_Beta>BETA</S_Beta>
            </>
        </S_LogoHeader>
    );
};

const S_LogoHeader = styled.div`
    display: flex;
    align-items: center;
`;

const S_SVG_Logo = styled(SVG_Logo)`
    svg {
        width: 170px;
        height: auto;
    }
`;

const S_Beta = styled.div`
    color: ${EColors.ACC2_A};
    font-size: 16px;
    font-family: ${EFonts.Bold};
    margin: 0 15px 0 25px;
`;
